var equal = require('buffer-equal')
var HEADER = new Buffer([66, 77, 70, 3])

module.exports = function(buf) {
  if (typeof buf === 'string')
    return buf.substring(0, 3) === 'BMF'
  return buf.length > 4 && equal(buf.slice(0, 4), HEADER)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/load-bmfont/lib/is-binary.js
// module id = 2006
// module chunks = 0